import TestRunsPage from "../../../runs";

interface RunsTabProps {
  testId: string;
}

export function RunsTab({ testId }: RunsTabProps) {
  return <TestRunsPage testId={testId} noHeader />;
}
